import {getPreference} from '@netx/core-user-next/utils/getPreference';

/**
 * @return Can contact
 */
export const canContact = () => getPreference('email.mailto.rcpt_to') != null;
